// extracted by mini-css-extract-plugin
export default {"info":"O2mV7w","actions":"_4yOR6g","actionItem":"kmAhNx"};